<ng-container *ngIf="(portal && !(mobile && hideBarOnMobile)) || (buttonsPortal && !(mobile && allowFab))">
  <div class="action-footer" [dir]="direction">
    <!-- Random content portal,
    use this if you don't wanna use FAB for button in mobile mode -->
    <ng-template [cdkPortalOutlet]="portal"></ng-template>
    <!-- Portal for buttons, which will be used in fab menu -->
    <ng-container *ngIf="!(allowFab && mobile)">
      <ng-template [cdkPortalOutlet]="buttonsPortal"></ng-template>
    </ng-container>
  </div>
</ng-container>

<!-- Floating Action Buttons Menu -->
<ng-container *ngIf="buttonsPortal && allowFab && mobile">
  <div class="fab" [dir]="direction" [class.fab--open]="fabOpen">
    <div class="fab__backdrop" [class.fab__backdrop--open]="fabOpen" (click)="onBackdropClicked($event)"></div>
    <!-- Review change to cwc (mobile) -->
    <cwc-button
      designVersion="v2"
      class="fab__toggle"
      [class.fab__toggle--open]="fabOpen"
      [rtl]="false"
      (cwcClick)="fabButtonOnClick($event)"
    >
      <span class="fab__icon cmx-icon-menu"></span>
    </cwc-button>
    <div class="fab__portal" [class.fab__portal--open]="fabOpen" [cdkPortalOutlet]="buttonsPortal"></div>
  </div>
</ng-container>
